import { Action } from '@ngrx/store';
import { BillGsmDetailsPaginatorInterface } from '../../../bills/models/bill-gsm-details.paginator.interface';

export enum EBillGsmDetailsActions {
  GetBillGsmDetails = '[BILL_GSM_DETAILS] Get bill gsm details',
  GetBillGsmDetailsSuccess = '[BILL_GSM_DETAILS] Get bill gsm details success',
  GetBillGsmDetailsFailure = '[BILL_GSM_DETAILS] Get bill gsm details failure',
}

/**
 * Get bill gsm details action and state to save in store
 */
export class GetBillGsmDetails implements Action {
  public readonly type = EBillGsmDetailsActions.GetBillGsmDetails;
  constructor(public phoneNumber: string, public month: number, public page: number, public items: number, public filter?: string) {}
}

/**
 * Get bill gsm details success action and state to save in store
 */
export class GetBillGsmDetailsSuccess implements Action {
  public readonly type = EBillGsmDetailsActions.GetBillGsmDetailsSuccess;
  constructor(public payload: BillGsmDetailsPaginatorInterface) {}
}

/**
 * Get bill gsm details failure action and state to save in store
 */
export class GetBillGsmDetailsFailure implements Action {
  public readonly type = EBillGsmDetailsActions.GetBillGsmDetailsFailure;
}

/**
 * Export actions
 */
export type GetBillGsmDetailsActions = GetBillGsmDetails | GetBillGsmDetailsSuccess | GetBillGsmDetailsFailure;
